const organization = {
  organizations: 'Comptes',
  search_organization: 'Rechercher un compte',
  add_organization: 'Nouveau Compte',
  controllers: 'Contrôleurs',
  organization: 'Compte',
  payment_methods: 'Méthodes de paiement',
  name_on_card: 'Nom sur la carte',
  card_number: 'Numéro de la carte',
  expiration_date: "Date d'expiration",
  is_default: 'définir comme défaut',
  expires_at: "Date d'expiration de la carte",
  select_organization_msg: 'Veuillez accéder aux comptes et en sélectionner un',
  summary: 'Résumé',
  single_site: 'Site unique',
  table: {
    company: 'ENTREPRISE',
    full_name: 'NOM ET PRÉNOM',
    email: 'COURRIEL',
    country: 'PAYS',
    address: 'ADRESSE',
    status: 'STATUT',
    site: 'SITE',
    organization: 'COMPTE',
    firmware_version: 'VERSION DU MICROLOGICIEL',
  },
  form: {
    secondContact: 'Deuxième contact',
    create_admin: 'Créer un utilisateur Administrateur',
    main_contact_first_name: 'Contact principal - Prénom',
    main_contact_last_name: 'Contact principal - Nom de famille',
    second_contact_first_name: 'Prénom',
    second_contact_last_name: 'Nom de famille',
  },
  information: {
    website: 'Site Internet',
  },
  modal: {
    delete_payment_description: 'Voulez-vous vraiment supprimer cette carte',
  },
  set_multisite_msg:
    'Êtes-vous sûr de vouloir modifier <b>{{name}}</b> de Site unique à Sites multiples',
  set_singlesite_msg:
    'Êtes-vous sûr de vouloir modifier <b>{{name}}</b> de Sites multiples à Site unique',
};

export default organization;
